import { api } from 'src/services/api';
import { PatientDocument } from 'src/models';

export type GenerateDocumentPreSignedPostUrlPayload = {
  mime_type: string;
  name: string;
  description: string;
  size: number;
};

export type GenerateDocumentPreSignedPostUrlResponse = {
  url: string;
  document: Record<string, string>;
};

export const generateDocumentPreSignedPostUrl = async (
  payload: GenerateDocumentPreSignedPostUrlPayload
) => {
  const response = await api.post(`/document/generate_presigned_url`, payload);
  return response.data;
};

export type CreatePatientDocumentPayload = {
  source: 'vca';
  description?: string;
} & (
  | {
      type: 'file';
      file: File;
      mime_type?: string;
      size?: number;
    }
  | {
      type: 'text';
      content: string;
    }
);

export type CreatePatientDocumentResponse = PatientDocument;

export const createPatientDocument = async (
  payload: CreatePatientDocumentPayload
): Promise<CreatePatientDocumentResponse> => {
  const { file, ...rest } = payload as PatientDocument & { file: File };
  const formData = new FormData();
  Object.entries(rest).forEach(([key, value]) => {
    formData.append(key, value as string);
  });
  if (file) {
    formData.append('file', file);
  }
  const response = await api.post(`/v3/document`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export type GetPatientDocumentPayload = {
  patient_document_id: string;
};
export type GetPatientDocumentResponse = PatientDocument;
export const getPatientDocument = async (
  payload: GetPatientDocumentPayload
): Promise<GetPatientDocumentResponse> => {
  const response = await api.get<GetPatientDocumentResponse>(
    `/v3/document/${payload.patient_document_id}`
  );
  return response.data;
};
